import BaseApiService from "@/api/BaseApiService"
import proxy from "@/api/proxy"
import { groupBookingInt } from "./Models/group-booking"
import { UpdateGroupBookingAndJourney } from "./Models/Update-Journeys-request"

const JourneyV3Service = {
  GetGroupBookingByGroupId(hotelId: string, groupId: string): Promise<groupBookingInt[]> {
    return BaseApiService.getAsync(proxy.HotelV3, `Journey/Hotels/${encodeURIComponent(hotelId)}/GroupBooking/GetByGroupId?groupId=${encodeURIComponent(groupId)}`)
  },
  GetJourneysByListOfPms(hotelId: string, groupId: string) {
    return BaseApiService.getAsync(proxy.HotelV3, `Journey/Hotels/GetJournesByGroupId?hotelId=${encodeURIComponent(hotelId)}&groupId=${encodeURIComponent(groupId)}`)
  },
  PutJourneyDataFromGroupBooking(bookingToBeUpdated: UpdateGroupBookingAndJourney) {
    return BaseApiService.putAsync(proxy.HotelV3, `Journey/Hotels/PutJourneyDataFromGroupBooking`, bookingToBeUpdated)
  },
}

export default JourneyV3Service
